<template>
  <div class="page-content sobre-box">
    <el-carousel
      class="banner"
      height="100%"
      direction="vertical"
      :autoplay="true"
    >
      <el-carousel-item
        v-for="(item, idx) in imgs"
        :key="idx+'_'"
        :label="'0' + (idx + 1)"
      >
        <img :src="require('../../assets/img/' + item)" />
      </el-carousel-item>
    </el-carousel>
    <div class="desc">
      <div class="desc-text"
      :class="{
          'slide-right': scrollHeight && isShow('desc-text', 'slide-right'),
        }"
      >
        <p class="">  
          A nuestros conocimientos en soluciones de eficiencia energética le sumamos
          la formación especializada en viviendas pasivas (PASSIVHAUS).
        </p>
        
        <p class="">
          Nuestro departamento técnico amplía las áreas de negocio con Servicios
          Exclusivos como jefatura de obra, asistencia técnica en fase de
        </p>
          
        <p class="">
          proyecto y/o ejecución, seguridad y salud, informes técnicos y
          periciales, mediciones y levantamiento de planos.</p>

      </div>
      <div class="desc-tips"
      :class="{
          'slide-top': scrollHeight && isShow('desc-tips', 'slide-top'),
        }"
      >
        <b class="font-blod">MARAGON</b>
        nace de la unión de un <br />
        equipo de profesionales con amplísima experiencia en el sector de la 
        construcción y obras de toda <br />
        índole con el objetivo de crear una <br />
        empresa de alta calidad en obra y <br />
        servicio al cliente.<br />
        <el-divider></el-divider>
        Esta experiencia la venimos desarrollando desde hace más de 15 <br />
        años en diversas áreas de la edificación,
        unifamiliares exclusivos, <br />
        viviendas en altura, retail, multitud <br />
        de reformas integrales y obra civil.
        <!-- <h1 class="font-blod">
          EFICIENCIA
          EN
          CONSTRUCCIÓN
        </h1> -->
      </div>
    </div>
    <div class="row-1">
      <img src="../../assets/img/home1.jpg" />
      <div
        class="row-1-text hide"
        :class="{
          'fade-in': scrollHeight && isShow('row-1-text', 'fade-in'),
        }"
      >
        <h1 class="font-blod">EFICIENCIA</h1>
        <h1 class="font-blod">EN CONSTRUCCIÓN</h1>
      </div>
    </div>
    <el-row
      class="sobre grid"
     
    >
      <el-col
        v-for="(item, idx) in list"
        :key="idx"
        class="grid-item "
        :class="{
          ['item' + idx]: true,
          'fade-in': scrollHeight && isShow('grid-item', 'fade-in') 
        }"
        :xs="24"
        :md="6"
        :span="8"
      >
        <div
          class="grid-item-body"
          :class="{
            'icon-bg': true,
            'panel-theme': 4 > idx && idx % 2 == 1 || idx >= 4 && idx % 2 == 0,
            'panel-black': 4 > idx && idx % 2 == 0 ||idx >= 4 && idx % 2 == 1,
          }"
        >
          <span class="icon">
            <img :src="require('../../assets/img/' + item.img)" />
          </span>

          <div class="item-text">
            <h1 class="header" v-html="item.header"></h1>
            <div class="text" v-html="item.text"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    scrollHeight: Number,
  },
  data() {
    return {
      imgs: [
        "home-banner1.jpg",
        "home-banner2.jpg",
        "home-banner3.jpg",
        "home-banner1.jpg",
      ],
      list: [
        {
          img: "panel1.svg",
          color: "#c5ba60",
          header: "EQUIPO MARAGON",
          text: `<p><b class="fontbold primary">Se lo ponemos fácil al cliente.</b> 
Con un equipo altamente especializado y en constante for
mación buscamos la máxima 
calidad y excelencia en nuestro 
trabajo. Todo ello a través de <b>la 
eficiencia en <b class="fontbold primary"> la construcción.</b></p>`,
        },
        {
          img: "panel2.svg",
          color: "#202b47",
          header: "SOMOS SOSTENIBLES",
          text: `<p>En tiempos donde la naturaleza y
             los recursos naturales ocupan un lugar predominante, Maragon  
está plenamente orientada a la  
sostenibilidad, respeto al medio  
ambiente y la adecuada gestión  
de los recursos existentes incorporando, en los últimos años, la  
construcción <b class="fontbold"> PASSIVHAUS</b>.</p> `,
        },
        {
          img: "panel3.svg",
          color: "#e1e3de",
          textColor: "#000",
          header: `ÚLTIMAS <br/> TECNOLOGÍAS`,
          text: `<p>Actualizamos nuestros conocimientos a través de formación continuada para ponerlos a disposición de nuestros clientes.</p> `,
        },
        {
          img: "panel4.svg",
          color: "#97aae5",
          header: `ACTITUD`,
          text: `<p>Una actitud positiva, proactiva y 
la voluntad de hacer el máximo 
esfuerzo por nuestros clientes y 
asociados son esenciales para el 
éxito de nuestra empresa.</p>`,
        },
        {
          img: "panel5.svg",
          color: "#000000",
          header: `ESTRUCTURA`,
          text: `<p>Tenemos una sencilla estructura
           que facilita y agiliza el flujo de 
comunicación e información, 
rapidez de respuesta y cumplimiento de compromisos.</p>`,
        },
        {
          img: "panel6.svg",
          color: "#50bac0",
          header: `SOLUCIONES <br/>INNOVADORAS`,
          text: `<p>La innovación e investigación de
            nuevas formas constructivas y de 
            materiales son esenciales, ya 
 que permiten crear objetos y edificios arquitectónicos sobresalientes.</p>`,
        },
        {
          img: "panel7.svg",
          color: "#50bac0",
          header: `INTEGRIDAD`,
          text: `<p>Estamos comprometidos con los
           más altos estándares éticos. Es 
lo que nuestros clientes esperan
 de nosotros y lo que nosotros 
esperamos de nuestros asociados.</p>`,
        },
        {
          img: "panel8.svg",
          color: "#50bac0",
          header: `PROFESIONALIDAD`,
          text: `<p>Somos profesionales comprometidos con una construcción 
eficiente, con la búsqueda de las 
mejores soluciones para nuestros clientes y con una gestión de 
obra sin sorpresas.</p>`,
        },
      ],
    };
  },
  watch: {
    scrollHeight() {
      this.init()
    },
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 800)
  },
  methods: {
    init() {
      if (this.isShow(`desc-text`, "slide-right")) {
        document.querySelector(`.desc-text`).className =
          document
            .querySelector(`.desc-text`)
            .className.replace("slide-right", "") + " slide-right"
      }
      if (this.isShow(`desc-text`, "slide-right")) {
        document.querySelector(`.desc-tips`).className =
          document
            .querySelector(`.desc-tips`)
            .className.replace("slide-top", "") + " slide-top"
      }
    },
    isShow(refName, a) {
      const l = document.querySelector("." + refName); 
      const isCls = l.className.indexOf(a) > -1;
      if (isCls) return true;
      // console.log(refName, a,this.$utils.isElementInViewport(l));
      return this.$utils.isElementInViewport(l)
    },
    openPage(idx) {
      this.$router.push({ path: `/obras?row=${idx}` });
    },
  },
};
</script>

<style lang="scss">
.sobre.grid .grid-item {
  .item-text {
    // position: absolute;
    position: relative;
    color: #fff;
    z-index: 1000;
    padding: 65px 37px 0px 65px;
    .header {
      // position: absolute;
      font-size: var(--font-size);
      color: #fff;
      z-index: 1000;
      padding-bottom: 36px;
    }
    .text,
    .text p {
      font-size:calc( var(--font-size) - 8px);
    }
    b {
      font-size:calc( var(--font-size) - 8px);

      &.primary {
        color: $--color-primary;
      }
    }
  }
  .grid-item-body {
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.sobre-box {
  padding-top: 0px;
  margin-top: 0px;
  .banner {
    margin-top: 0px;
    height: 1080px;
    background: rgb(183, 183, 183);
    img {
      height: 1080px;
      object-fit: cover;
    }
  }
}
.el-divider {
  background-color: #ffffff;
  margin-top: 80px;
  margin-top: 70px;
}
.desc {
  padding-top: 132px;
  margin-bottom: 205px;
  .desc-text {
    width: 1160px;
    p {
      font-size:calc( var(--font-size) - 4px);
      line-height: 50px;
    }
  }
  .desc-tips {
    padding-top: 109px;
    padding-bottom: 160px;
    font-size:calc( var(--font-size) - 4px);
    line-height: 52px;
  }
  .first {
    margin-bottom: 60px;
  }
}
.row-1 {
  // padding-left: 50px;
  // padding-right: 50px;
  img {
    width: calc(100% - (42px * 2));
    left: 42px;
    right: 42px;
  }
  .row-1-text {
    text-align: center;
    animation-delay: 0.5s;
  }
}
.fade {
  opacity: 1;
  .grid-item {
    opacity: 1;
    transform: all 1s ease;
  }
}
.grid-item {
  opacity: 0;
  margin-top: 69px;
  .header {
    font-size: 32px;
  }
  .grid-item-body {
    position: relative;
    height: 635px;
    padding-bottom: 69px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .icon {
      width: 138px;
      height: 138px;
      position: absolute;
      top: -69px;
      left: 0px;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 100%;
      z-index: 10;
      img {
        width: 96px;
        height: 96px;
        object-fit: contain;
      }
    }
    .icon-bg {
      position: absolute;
      object-fit: contain;
    }
    &.panel-theme,
    &.panel-theme .icon {
      background-color: $--color-primary;
    }
    &.panel-black,
    &.panel-black .icon {
      background-color: #000;
    }
  }
}
</style>
